import clsx from "clsx";
import { isNil } from "lodash";
import { NoData } from "../../../../components";
import Number from "../../../../components/Number";

interface ThirdPartyMaliciousStatsProp {
  maliciousCount: number | undefined;
  totalCount: number | undefined;
  className?: string;
}

const ThirdPartyReputationStats: React.FC<ThirdPartyMaliciousStatsProp> = ({
  maliciousCount = 0,
  totalCount,
  className
}) => {
  if (isNil(maliciousCount) || isNil(totalCount)) return <NoData />;
  return (
    <span className={className}>
      <Number
        className={clsx(
          `threat-text--${maliciousCount ? "malicious" : "unknown"}`,
          maliciousCount && "font-medium"
        )}
        num={maliciousCount}
        shouldAbbreviate
      />
      /
      <Number num={totalCount} shouldAbbreviate />
    </span>
  );
};

export default ThirdPartyReputationStats;
